import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "template-config",
    templateUrl: "./template-config.view.html",
    providers: []
})
export class TemplateConfigView implements OnInit {
    selectedLayout = "l_circular";
    baseUrl = "";
    isCard = false;
    catalogLayoutConfig;
    templateStyles: any = [
        {
            label: "Layout w/ Banner Image",
            code: "l_banner"
        },
        {
            label: "Layout w/ Circular Image",
            code: "l_circular"
        },
        {
            label: "Layout w/ Square Image",
            code: "l_square"
        },
        {
            label: "Layout without Image",
            code: "l_noimage"
        }
    ];

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);

        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = sharedService.sessionUrl;
            this.selectedLayout = this.sharedService.sessionLayoutConfig[this.baseUrl].layout;
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.selectedLayout = this.sharedService.speakerLayoutConfig.layout;
        }

        if(this.catalogLayoutConfig.highlightedStyle == "card" || 
        this.catalogLayoutConfig.promotedStyle == "card" || 
        this.catalogLayoutConfig.generalStyle == "card") {
            this.isCard = true;
        }
    }

    ngOnInit() {}

    changeTemplate(selectedLayout) {
        this.selectedLayout = selectedLayout;
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.sharedService.sessionLayoutConfig[this.baseUrl].layout = selectedLayout;
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.sharedService.speakerLayoutConfig.layout = selectedLayout;
        }
    }
}
